// src/features/auth/authTokensSlice.ts
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { AuthTokens } from '@/types/auth'

interface AuthTokensState {
  accessToken: string
  refreshToken: string
}

const initialState: AuthTokensState = {
  accessToken: '',
  refreshToken: '',
}

export const authTokensSlice = createSlice({
  name: 'authTokens',
  initialState,
  reducers: {
    setTokens: (state, action: PayloadAction<AuthTokens>) => {
      state.accessToken = action.payload.accessToken
      state.refreshToken = action.payload.refreshToken
    },
    clearAuthTokens: (state) => {
      state.accessToken = ''
      state.refreshToken = ''
    },
  },
})

export const { setTokens, clearAuthTokens } = authTokensSlice.actions
export const authTokensReducer = authTokensSlice.reducer
